import { Option } from "../../models/option";

export const tournamentStatus: Option[] = [
  {name: 'pending', value: 'PENDING'},
  {name: 'in-progress', value: 'IN_PROGRESS'},
  {name: 'finished', value: 'FINISHED'},
  {name: 'archived', value: 'ARCHIVED'},
];